// src/components/CompanyDetails/segmentare/SegmentarePeJudet.js
import React, { useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_ro from "@amcharts/amcharts4-geodata/romaniaLow";
import am4geodata_md from "@amcharts/amcharts4-geodata/moldovaLow";
import am4lang_ro from "@amcharts/amcharts4/lang/ro_RO";
import { useStoreState } from "easy-peasy";
import _zipObject from "lodash/zipObject";

const SegmentareDomeniiPeJudete = () => {
    const segmentareActivitate = useStoreState(
        (state) => state.companyProfile.companyProfile.segmentareActivitatePeJudete
    );
    const isMoldovaEnvironment = useStoreState(
        (state) => state.companyProfile.isMoldovaEnvironment
    );

    useEffect(() => {
        // 0) Date prezente?
        if (!segmentareActivitate || !segmentareActivitate.length) {
            console.warn("[MAP] stop: segmentareActivitate lipsă sau goală");
            return;
        }

        // 1) Container existent + dimensiuni
        var containerEl = document.getElementById("segmentare-domenii-judete-chart");
        if (!containerEl) {
            console.error("[MAP] container inexistent (#segmentare-domenii-judete-chart)");
            return;
        }
        // forțează înălțime utilă; dacă un CSS extern o calcă, tot rămâne minHeight
        containerEl.style.minHeight = "600px";
        containerEl.style.height = "600px";
        containerEl.style.display = "block";

        try {
            var rect = containerEl.getBoundingClientRect();
            console.debug(
                "[MAP] start",
                "env=", isMoldovaEnvironment ? "MD" : "RO",
                "segm.len=", segmentareActivitate.length,
                "rect=", { w: rect.width, h: rect.height, top: rect.top, left: rect.left }
            );
        } catch (e) {
            console.warn("[MAP] n-am putut loga rect:", e);
        }

        const segmentareDict = _zipObject(
            segmentareActivitate.map((i) => i.judetShortName),
            segmentareActivitate.map((i) => i.total || 0)
        );

        let chart;
        try {
            console.time("[MAP] create");
            chart = am4core.create(containerEl, am4maps.MapChart);
            console.timeEnd("[MAP] create");
        } catch (err) {
            console.error("[MAP] am4core.create FAILED:", err);
            return;
        }

        console.log(
            "[MAP] env flag in component:",
            isMoldovaEnvironment ? "MD" : "RO"
        );

        // Setări bază chart
        chart.geodata = isMoldovaEnvironment ? am4geodata_md : am4geodata_ro;
        chart.projection = new am4maps.projections.Miller();
        chart.paddingRight = 20;
        chart.height = 600;
        if (chart.svgContainer && chart.svgContainer.htmlElement) {
            chart.svgContainer.htmlElement.style.height = "600px";
        }
        chart.language.locale = am4lang_ro;

        const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
        polygonSeries.useGeodata = true;

        // debug validare serie
        polygonSeries.events.on("validated", function () {
            console.debug("[MAP] polygons validated -> count=", polygonSeries.mapPolygons.length);
        });
        chart.events.on("ready", function () {
            var el = chart.svgContainer && chart.svgContainer.htmlElement;
            var w = el ? el.clientWidth : null;
            var h = el ? el.clientHeight : null;
            console.debug("[MAP] chart ready, size=", { w: w, h: h });
        });

        // dataFields
        polygonSeries.dataFields.id = "id";
        polygonSeries.dataFields.value = "value";

        // template
        const polygonTemplate = polygonSeries.mapPolygons.template;
        polygonTemplate.tooltipText = "{name}";
        polygonTemplate.fill = am4core.color("#f3f3f3");
        polygonTemplate.strokeOpacity = 1;
        polygonTemplate.strokeWidth = 1;
        polygonTemplate.nonScalingStroke = true;
        polygonTemplate.stroke = am4core.color("#ffffff");

        // hover
        const hs = polygonTemplate.states.create("hover");
        hs.properties.fill = am4core.color("#2b4566");

        // excluderi (de siguranță)
        polygonSeries.exclude = ["AQ"];

        // heat rule
        const heatRule = {
            property: "fill",
            target: polygonSeries.mapPolygons.template,
            min: am4core.color("#9cd919"),
            max: am4core.color("#005b01"),
        };
        polygonSeries.heatRules.push(heatRule);

        // date serie
        polygonSeries.data = segmentareActivitate.map((item) => ({
            id: (isMoldovaEnvironment ? "MD-" : "RO-") + item.judetShortName,
            name: item.judetShortName,
            value: Number(item.total) || 0,
        }));

        // domeniu heatmap
        const vals = polygonSeries.data.map((d) => d.value);
        const maxVal = Math.max(0, Math.max.apply(null, vals.length ? vals : [0]));
        heatRule.minValue = 0;
        heatRule.maxValue = Math.max(1, maxVal);

        // coordonate pentru label-uri (MD)
        // notă: sunt aproximative, centrate pe orașul/raionul principal

        var mdlongitude = {
            "MD-AN": 29.12,
            "MD-BA": 27.88,
            "MD-BD": 29.44,
            "MD-BR": 26.90,
            "MD-BS": 28.85,
            "MD-CA": 28.15,
            "MD-CT": 28.20,
            "MD-CS": 29.25,
            "MD-CL": 28.20,
            "MD-CM": 28.65,
            "MD-CR": 28.90,
            "MD-DO": 27.54,
            "MD-DR": 27.75,
            "MD-DU": 29.00,
            "MD-ED": 27.20,
            "MD-FA": 27.65,
            "MD-FL": 28.25,
            "MD-GA": 28.60,
            "MD-GL": 27.42,
            "MD-HI": 28.30,
            "MD-IA": 28.79,
            "MD-LE": 28.30,
            "MD-NI": 28.08,
            "MD-OC": 27.35,
            "MD-OR": 28.70,
            "MD-RE": 28.77,
            "MD-RI": 27.40,
            "MD-SD": 28.60,
            "MD-SI": 28.04,
            "MD-SN": 29.64,
            "MD-SO": 28.20,
            "MD-ST": 28.50,
            "MD-SV": 29.59,
            "MD-TA": 28.55,
            "MD-TE": 28.44,
            "MD-UN": 27.85,
            "MD-CU": 28.72
        };

        var mdlatitude = {
            "MD-AN": 46.98,
            "MD-BA": 47.83,
            "MD-BD": 46.90,
            "MD-BR": 48.36,
            "MD-BS": 46.42,
            "MD-CA": 45.90,
            "MD-CT": 46.27,
            "MD-CS": 46.74,
            "MD-CL": 47.35,
            "MD-CM": 46.62,
            "MD-CR": 47.24,
            "MD-DO": 48.30,
            "MD-DR": 48.10,
            "MD-DU": 47.38,
            "MD-ED": 48.20,
            "MD-FA": 47.60,
            "MD-FL": 47.93,
            "MD-GA": 46.25,
            "MD-GL": 47.77,
            "MD-HI": 46.90,
            "MD-IA": 46.85,
            "MD-LE": 46.56,
            "MD-NI": 47.15,
            "MD-OC": 48.47,
            "MD-OR": 47.45,
            "MD-RE": 47.70,
            "MD-RI": 47.98,
            "MD-SD": 47.88,
            "MD-SI": 47.70,
            "MD-SN": 47.40,
            "MD-SO": 48.18,
            "MD-ST": 47.20,
            "MD-SV": 46.60,
            "MD-TA": 45.99,
            "MD-TE": 47.62,
            "MD-UN": 47.37,
            "MD-CU": 47.10
        };


        // coordonate pentru label-uri (RO)
        var longitude = {
            "RO-B": 26.40, "RO-AB": 23.32, "RO-AR": 21.65, "RO-AG": 24.67, "RO-BC": 26.66,
            "RO-BH": 22.05, "RO-BN": 24.42, "RO-BT": 26.72, "RO-BV": 25.15, "RO-BR": 27.52,
            "RO-BZ": 26.58, "RO-CL": 26.90, "RO-CS": 21.95, "RO-CJ": 23.45, "RO-CT": 28.11,
            "RO-CV": 25.84, "RO-DB": 25.35, "RO-DJ": 23.55, "RO-GL": 27.59, "RO-GR": 25.79,
            "RO-GJ": 23.22, "RO-HR": 25.43, "RO-HD": 22.76, "RO-IL": 26.99, "RO-IS": 27.26,
            "RO-IF": 26.03, "RO-MM": 23.73, "RO-MH": 22.69, "RO-MS": 24.39, "RO-NT": 26.20,
            "RO-OT": 24.30, "RO-PH": 25.82, "RO-SM": 22.60, "RO-SJ": 22.99, "RO-SB": 24.10,
            "RO-SV": 25.65, "RO-TR": 25.03, "RO-TM": 21.15, "RO-TL": 28.50, "RO-VS": 27.59,
            "RO-VL": 24.00, "RO-VN": 26.77
        };
        var latitude = {
            "RO-B": 44.10, "RO-AB": 46.22, "RO-AR": 46.33, "RO-AG": 45.05, "RO-BC": 46.45,
            "RO-BH": 47.05, "RO-BN": 47.30, "RO-BT": 47.85, "RO-BV": 45.80, "RO-BR": 45.16,
            "RO-BZ": 45.35, "RO-CL": 44.40, "RO-CS": 45.24, "RO-CJ": 46.82, "RO-CT": 44.31,
            "RO-CV": 46.00, "RO-DB": 44.96, "RO-DJ": 44.20, "RO-GL": 45.86, "RO-GR": 44.15,
            "RO-GJ": 45.08, "RO-HR": 46.59, "RO-HD": 45.72, "RO-IL": 44.70, "RO-IS": 47.30,
            "RO-IF": 44.69, "RO-MM": 47.72, "RO-MH": 44.58, "RO-MS": 46.62, "RO-NT": 47.00,
            "RO-OT": 44.40, "RO-PH": 45.20, "RO-SM": 47.68, "RO-SJ": 47.20, "RO-SB": 45.85,
            "RO-SV": 47.62, "RO-TR": 44.12, "RO-TM": 45.76, "RO-TL": 45.05, "RO-VS": 46.58,
            "RO-VL": 45.20, "RO-VN": 45.86
        };

        // label-uri pe hartă
        const labelSeries = chart.series.push(new am4maps.MapImageSeries());
        const labelTemplate = labelSeries.mapImages.template.createChild(am4core.Label);
        labelTemplate.fontSize = 14;
        labelTemplate.nonScaling = true;
        labelTemplate.interactionsEnabled = false;

        if (process.env.NODE_ENV === "development") {
            window.testMdLabel = (id, lat, lng, text) => {
                const img = labelSeries.mapImages.create();
                img.latitude = lat;
                img.longitude = lng;

                const lbl = img.createChild(am4core.Label);
                lbl.text = text || id;
                lbl.fontSize = 14;
                lbl.nonScaling = true;

                console.log("[MAP DEV] label creat pentru", id, "la", { lat, lng });
                return img;
            };
        }

        polygonSeries.events.on("inited", function () {
            polygonSeries.mapPolygons.each(function (polygon) {
                const ctx = polygon.dataItem && polygon.dataItem.dataContext;
                if (!ctx || !ctx.id) return;

                const label = labelSeries.mapImages.create();
                var id = String(ctx.id);
                var code = id.indexOf("-") >= 0 ? id.split("-").pop() : id;

                var totalVal = segmentareDict[code] ? segmentareDict[code] : 0;
                var text = code + " " + totalVal;

                if (!isMoldovaEnvironment) {
                    label.latitude = latitude[id];
                    label.longitude = longitude[id];
                } else {
                    label.latitude = mdlatitude[id];
                    label.longitude = mdlongitude[id];
                }
                // dacă n-avem coordonate, nu plasăm label
                if (typeof label.latitude !== "number" || typeof label.longitude !== "number") {
                    // pentru debug, vezi ce id a rămas fără coords
                    console.warn("[MAP] lipsă coords pentru", id);
                    return;
                }
                label.children.getIndex(0).text = text;
            });
        });

        chart.seriesContainer.resizable = false;
        chart.maxZoomLevel = window.screen.availWidth > 1000 ? 1 : 3;
        if (window.screen.availWidth < 1000) chart.homeZoomLevel = 3;



        // unele layout-uri au nevoie de un invalidateSize după ce cardul devine vizibil
        setTimeout(function () {
            try {
                chart.invalidateSize();
                console.debug("[MAP] invalidateSize() după mount");
            } catch (e) {
                // noop
            }
        }, 300);

        // cleanup
        return () => {
            try {
                if (chart) {
                    chart.dispose();
                    // console.debug("[MAP] chart disposed");
                }
            } catch (e) {
                // noop
            }
        };
    }, [segmentareActivitate, isMoldovaEnvironment]);

    return (
        <div className="chart">
            <div id="segmentare-domenii-judete-chart"></div>
        </div>
    );
};

export default SegmentareDomeniiPeJudete;
